export default __webpack_public_path__ + "media/components/Pages/Index/Images/Lang-139ece3bfa81fa5c3827eeca91a82750.svg";